import FeaturedIcon from "../FeaturedIcon/FeaturedIcon";
import { Alert } from "../Icon/Icon";
import styles from "./NoResults.module.scss";

function NoResults({
  resourceName,
  isFiltered,
}: {
  resourceName: string;
  isFiltered: boolean;
}) {
  return (
    <div className={styles.container}>
      <FeaturedIcon IconComponent={Alert} />
      {isFiltered ? (
        <>
          <p className={styles.heading}>
            No {resourceName} found for your current filters
          </p>
          <p className={styles.caption}>
            Try changing the filters you have applied
          </p>
        </>
      ) : (
        <p className={styles.heading}>No {resourceName} created</p>
      )}
    </div>
  );
}

export default NoResults;
